import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import Element451ReaderForm from '../forms/element451-reader-form';
import { element451ReaderValidationSchema } from '../schema/element451Reader.js';

export default function Element451ReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Element451 Reader Node Details',
        altText: 'Element451 Reader Node',
        defaultLabel: 'Element451 Reader Node',
      }}
    >
      <CommonNode
        FormComponent={Element451ReaderForm}
        schemaResolver={element451ReaderValidationSchema}
      />
    </NodeProvider>
  );
}
